import { createSelector } from '@reduxjs/toolkit';
import { getTermsValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectHouseMaterial = createSelector(selectJsonQuery, jsonQuery =>
  getTermsValue('house_material')(jsonQuery),
);
